import { render, staticRenderFns } from "./ActionsProfile.vue?vue&type=template&id=653ecb78&scoped=true&"
import script from "./ActionsProfile.vue?vue&type=script&lang=js&"
export * from "./ActionsProfile.vue?vue&type=script&lang=js&"
import style0 from "./ActionsProfile.vue?vue&type=style&index=0&id=653ecb78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653ecb78",
  null
  
)

export default component.exports